export default __webpack_public_path__ + "static/media/gallery14.268c3796.jpg";